export default __webpack_public_path__ + "static/media/glitch02.f6986143.png";